// extracted by mini-css-extract-plugin
export var dropdownButton = "_3p-0";
export var fullWidthDropdownButton = "_3p-1";
export var icon = "_3p-3";
export var iconPlaceholder = "_3p-2";
export var menuItemRow = "_3p-9";
export var separator = "_3p-e";
export var shortcutContainer = "_3p-7";
export var shortcutContainerFilled = "_3p-8";
export var shortcutIconLg = "_3p-6";
export var shortcutIconMd = "_3p-5";
export var shortcutIconSm = "_3p-4";
export var submenuChevron = "_3p-d";
export var submenuDropdown = "_3p-a";
export var submenuTriggerRow = "_3p-b";
export var submenuTriggerRowOpen = "_3p-c";